/**
 * @deprecated Replaced with jquery.module-stage-video.js
 *
 * @name          stage-video
 * @version       1.0
 * @lastmodified  2016-02-09
 * @package       html-css-js
 * @subpackage    jQuery plugin
 * @author        VI
 *
 * based on: http://jqueryboilerplate.com/
 */

;(function ($, undefined) {
	'use strict';

	var pluginName = 'stageVideo',
		defaults = {};

	// The actual plugin constructor
	function Plugin(element, options) {

		var self = this;
		self.$element = $(element);
		self.options = $.extend({}, defaults, options);
		self.init();
	}

	// methods
	var methods = {
		init: function () {
			var self = this;

			// init listeners for stage and video events
			self.initListeners();

			// move video container into body
			self.$videoWrapper = self.$element.find('.stage__video');

			// init objectFit polyfill on megaStage images
			if (!Modernizr.objectfit && typeof $.fn.objectFit === 'function') {
				$('.stage__image img').objectFit();
			}

			//init video in stage
			self.videoInstance = videojs(self.$videoWrapper.find('video').get(0), {
				fluid: true,
				preload: 'metadata'
			}, function () {
			});


			self.videoInstance.on('play', function () {
				var string = this.player_.cache_.source.src;
				var filename = string.substring(string.lastIndexOf('/') + 1);
				var time = parseInt(this.currentTime() / 60, 10).toLocaleString('en-US', {
					minimumIntegerDigits: 2,
					useGrouping: false
				}) + ':' + Math.round(this.currentTime() % 60).toLocaleString('en-US', {
					minimumIntegerDigits: 2,
					useGrouping: false
				});
				var type = 'PLAY';
				window.trackVideo(filename, time, type);
			});

			self.videoInstance.on('pause', function () {
				var string = this.player_.cache_.source.src;
				var filename = string.substring(string.lastIndexOf('/') + 1);
				var time = parseInt(this.currentTime() / 60, 10).toLocaleString('en-US', {
					minimumIntegerDigits: 2,
					useGrouping: false
				}) + ':' + Math.round(this.currentTime() % 60).toLocaleString('en-US', {
					minimumIntegerDigits: 2,
					useGrouping: false
				});
				var type = 'STOP';
				window.trackVideo(filename, time, type);
			});

		},

		initListeners: function () {

			var self = this;

			self.$closeIcon = self.$element.find('.stage__closeicon');

			// show video
			self.$element.find('.stage__playbutton, .stage__positionWrap').on('click', function (e) {
				e.preventDefault();
				self.$element.find('.stage__image').addClass('showVideo');
				self.$videoWrapper.addClass('show');
				self.videoInstance.play();
			});

			// hide video
			self.$closeIcon.on('click', function (e) {
				e.preventDefault();

				self.videoInstance.pause();
				self.$element.find('.stage__image').removeClass('showVideo');
				var waitForTransition = 0;
				if ($(window).width() > global.configuration.data.global.bpMediumMax && !$('html').hasClass('ie')) {
					waitForTransition = 600;
				}
				setTimeout(function () {
					self.$videoWrapper.removeClass('show');
				}, waitForTransition);
			});

			// listen to ESC key
			$(document).on('keyup.stopVideo', function (evt) {
				if (evt.keyCode === 27) {
					self.$closeIcon.trigger('click');
				}
			});
		}
	};

	// build
	$.extend(Plugin.prototype, methods);

	// A really lightweight plugin wrapper around the constructor,
	// preventing against multiple instantiations
	$.fn[pluginName] = function (options) {
		this.each(function () {
			if ($(this).find('.module-stage-video').length) {
				return;
			}

			if (!$.data(this, 'plugin_' + pluginName)) {
				$.data(this, 'plugin_' + pluginName, new Plugin(this, options));

				// trigger ready event on element
				// $.triggerFailsafeEvent($(this), 'plugin_' + pluginName + '.ready');
			}
		});

		// trigger ready event globally
		// if (this.length > 0) {
		// 	$.triggerFailsafeEvent($(window), 'plugin_' + pluginName + '.ready_all');
		// }

		return this;
	};

})(jQuery, window, document);
